/**
 * Classes for all defined by backend api v9.0 error codes.
 * (base errors are excluded).
 */
import {i18n} from '@yourcoach/i18n';

import type {RpcError} from './types';

import {RpcRequestError} from './base';

export class ErrorApiUndefined extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorApiUndefined';
  }
}

export class ErrorJwtExpired extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorJwtExpired';
  }
}

export class ErrorJwtInvalid extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorJwtInvalid';
  }
}

export class ErrorResourceCannotDelete extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceCannotDelete';
  }
}

export class ErrorResourceFailedConstraint extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceFailedConstraint';
  }
}

export class ErrorResourceInvalidContext extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceInvalidContext';
  }
}

export class ErrorResourceQueryInvalidValue extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceQueryInvalidValue';
  }
}

export class ErrorResourceQueryUndefinedField extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceQueryUndefinedField';
  }
}

export class ErrorResourceQueryUnsupportedOperator extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceQueryUnsupportedOperator';
  }
}

export class ErrorResourceUnreachable extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceUnreachable';
  }
}

export class ErrorResourceUserBanned extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceUserBanned';
  }
}

export class ErrorResourceUserBannedMethod extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceUserBannedMethod';
  }
}

export class ErrorResourceUserBlockedAccount extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceUserBlockedAccount';
  }
}

export class ErrorResourceUserExpiredCode extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceUserExpiredCode';
  }
}

export class ErrorResourceUserExpiredSession extends RpcRequestError {
  constructor(
    error: RpcError = {
      code: 'error.resource.user.expired_session',
      message: '',
    },
    sentParams: any = {},
  ) {
    super(error, sentParams);
    this.name = 'ErrorResourceUserExpiredSession';
  }
}

export class ErrorResourceUserInvalidCode extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceUserInvalidCode';
  }
}

export class ErrorResourceUserTooManyAttempts extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceUserTooManyAttempts';
  }
}

export class ErrorResourceUserUndefinedAuthId extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorResourceUserUndefinedAuthId';
  }
}

export class ErrorRpcAccessDenied extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorRpcAccessDenied';
  }
}

export class ErrorRpcInternal extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorRpcInternal';
  }
}

export class ErrorRpcInvalidParams extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorRpcInvalidParams';
  }
}

export class ErrorRpcInvalidRequest extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorRpcInvalidRequest';
  }
}

export class ErrorRpcParse extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorRpcParse';
  }
}

export class ErrorRpcUndefinedMethod extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorRpcUndefinedMethod';
  }
}

export class ErrorRpcUnsupportedVersion extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorRpcUnsupportedVersion';
  }
}

export class ErrorSubscriptionExpired extends ErrorRpcAccessDenied {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorSubscriptionExpired';
    this.message = i18n.t('shared:message.subscription_expired');
  }
}

export class ErrorVendorOpentok extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorVendorOpentok';
  }
}

export class ErrorVendorRecaptcha extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorVendorRecaptcha';
  }
}

export class ErrorVendorS3 extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorVendorS3';
  }
}

export class ErrorVendorStripe extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorVendorStripe';
  }
}

export class ErrorVendorStripeCard extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'ErrorVendorStripeCard';
  }
}

/*********************** custom ***************************/

export class WarningRpcDeprecated extends RpcRequestError {
  constructor(error: RpcError, sentParams: any = {}) {
    super(error, sentParams);
    this.name = 'WarningRpcDeprecated';
  }
}
